import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const Attachments = withAsync({
	loader: lazyForPaint(() => import(/* webpackChunkName: "attachments" */ './attachments')),
});
